import React, { memo } from 'react';
import { HamburgerMenu } from '../components/HamburgerMenu';
import { Hero } from '../components/Hero';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { SEO } from '../components/SEO';
import { VisitUs } from '../components/VisitUs';
import { cafeStructuredData } from '../seo/structuredData';
import { motion } from 'framer-motion';
import { Coffee, Users, MapPin, Sunrise, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#D97E3A] selection:text-white" data-id="element-337" data-mp="260ocby2imwyu">
      <SEO title="Grounded - Community Coffee Shop in Livermore, CA" description="Grounded is a neighborhood coffee shop in Livermore, CA serving craft espresso, made-to-order sandwiches, and fresh pastries. Open daily 7am–2pm. Catering & event space available." canonical="https://www.groundedlivermore.com/" structuredData={cafeStructuredData} data-id="element-338" data-mp="2kxfh6muyl0vu" />
      <HamburgerMenu data-id="element-339" data-mp="2zjyktojd48it" />

      <main data-id="element-340" data-mp="2zkhzmwdpugsm">
        <Hero data-id="element-341" data-mp="2zgu8u4zno8hl" />

        {/* Welcome Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto" data-id="element-342" data-mp="33jqwwb7yswsx">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-343" data-mp="38jvey5oitzl9">
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-344" data-mp="38hscgm66mdzn">
              <h2 className="font-bebas text-6xl md:text-8xl mb-8 leading-[0.9]" data-id="element-345" data-mp="3rawaejqfnd02">
                WELCOME TO <br data-id="element-346" data-mp="3a2ug0leqdx" />
                <span className="text-[#D97E3A]" data-id="element-347" data-mp="1pej84vg3oi">GROUNDED</span>
              </h2>
              <p className="font-inter text-lg text-white/70 leading-relaxed mb-8" data-id="element-348" data-mp="1wxwpqc773slx">
                We're more than just a coffee shop, we're a gathering place for
                Livermore locals - A spot to unwind, connect, and enjoy each
                other's company. Our mission is simple: serve great coffee and
                help build a stronger community... one cup at a time.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-12" data-id="element-349" data-mp="3e4nze0g5p1gj">
                <div className="flex flex-col gap-3" data-id="element-350" data-mp="3964cnxtqnln4">
                  <Coffee className="text-[#D97E3A]" size={32} data-id="element-351" data-mp="3o4oo61wso9s4" />
                  <h3 className="font-bebas text-2xl" data-id="element-352" data-mp="3o2u1oj5vk9lx">Craft Coffee</h3>
                  <p className="text-sm text-white/50 font-inter" data-id="element-353" data-mp="3j52bpuosixkd">
                    Locally roasted beans brewed to perfection.
                  </p>
                </div>
                <div className="flex flex-col gap-3" data-id="element-354" data-mp="3sv53xso387hn">
                  <Users className="text-[#D97E3A]" size={32} data-id="element-355" data-mp="3sxriic9ebn9d" />
                  <h3 className="font-bebas text-2xl" data-id="element-356" data-mp="aqto7114kwz2">Community</h3>
                  <p className="text-sm text-white/50 font-inter" data-id="element-357" data-mp="5r77ghm38yli">
                    A space for everyone to feel at home.
                  </p>
                </div>
                <div className="flex flex-col gap-3" data-id="element-358" data-mp="pao4feo3nvdm">
                  <MapPin className="text-[#D97E3A]" size={32} data-id="element-359" data-mp="uaslb5sx6s4d" />
                  <h3 className="font-bebas text-2xl" data-id="element-360" data-mp="fetedyhjqy0t">Local</h3>
                  <p className="text-sm text-white/50 font-inter" data-id="element-361" data-mp="febacfon7fic">
                    Proudly serving Livermore since 2023.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative aspect-square lg:aspect-[4/5]" data-id="element-362" data-mp="6k6efhunjdvy">
              <div className="absolute inset-0 border-2 border-[#D97E3A] translate-x-4 translate-y-4 z-0" data-id="element-363" data-mp="3numlxntwgz5q"></div>
              <img src="https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=2574&auto=format&fit=crop" alt="Pouring coffee" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 z-10" data-id="element-364" data-mp="3gpv5gzh7whur" />
            </motion.div>
          </div>
        </section>

        {/* Grounded Mornings Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#111] border-y border-white/5" data-id="element-365" data-mp="2y1zxjw8ady9k">
          <div className="max-w-7xl mx-auto" data-id="element-366" data-mp="2t00w4rw3xbf9">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-367" data-mp="2o291hq42vb7d">
              <div className="relative aspect-[4/3] overflow-hidden" data-id="element-368" data-mp="psjy5ncxvdx1">
                <img src="https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?q=80&w=2670&auto=format&fit=crop" alt="Breakfast catering spread" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-369" data-mp="ttlpli0m6log" />
                <div className="absolute inset-0 bg-gradient-to-r from-[#111] via-transparent to-transparent lg:opacity-100 opacity-60" data-id="element-370" data-mp="6vs88v2w60k0"></div>
              </div>

              <div data-id="element-371" data-mp="fucl3flrtg0b">
                <div className="flex items-center gap-3 mb-6" data-id="element-372" data-mp="ftuf3r9b3nf7">
                  <Sunrise className="text-[#D97E3A]" size={40} strokeWidth={1.5} data-id="element-373" data-mp="ktp8q2kgur3y" />
                  <h2 className="font-bebas text-5xl md:text-7xl leading-[0.9]" data-id="element-374" data-mp="1r9sx4kmgpjsk">
                    GROUNDED <span className="text-[#D97E3A]" data-id="element-375" data-mp="1w7kn393jqvu4">MORNINGS</span>
                  </h2>
                </div>

                <p className="font-inter text-lg text-white/70 leading-relaxed mb-8" data-id="element-376" data-mp="16n329e2la7wn">
                  Bring the Grounded experience to your venue. Our catering
                  service delivers the same elevated hospitality that makes our
                  shop special - perfect for corporate meetings, weddings, and
                  community gatherings.
                </p>

                <Link to="/catering" className="inline-flex items-center gap-3 bg-white text-[#0a0a0a] px-8 py-4 font-bebas text-xl tracking-wide hover:bg-white/90 transition-all hover:scale-[1.03] group" data-id="element-377" data-mp="nv0g5n76hzf0">
                  EXPLORE CATERING
                  <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} data-id="element-378" data-mp="sstoomvyf5ig" />
                </Link>
              </div>
            </motion.div>
          </div>
        </section>

        {/*
          ARCHIVED: The "Memory Care Together" teaser section previously sat
          here, between Grounded Mornings and Visit Us. It has been removed
          from the live homepage but the page itself is preserved at
          pages/MemoryCareTogether.tsx. See the disabled route in App.tsx for
          full restore instructions.
         */}

        <VisitUs data-id="element-379" data-mp="26tgcr172i0s7" />

        <NewsletterSignup data-id="element-380" data-mp="2uireakw8rz7e" />

        {/* Footer Teaser */}
        <footer className="border-t border-white/10 py-12 text-center" data-id="element-381" data-mp="2ujakx5gfz164">
          <p className="font-bebas text-2xl text-white/50" data-id="element-382" data-mp="2zi41j6r0z8ai">
            © {new Date().getFullYear()} GROUNDED LIVERMORE
          </p>
        </footer>
      </main>
    </div>;
}